import projects from './projects';

const project = projects[0];

export default project;